/**
 * Footer Top Section Intersection Observer
 * Adds a class when the footer-top section enters the viewport
 */

class FooterTopObserver {
  constructor() {
    // Target the section by its ID pattern or data attribute
    this.section = document.querySelector('[data-footer-top-section], section[id*="footer-top"]');
    
    if (!this.section) {
      return;
    }

    this.init();
  }

  init() {
    // Check if browser supports Intersection Observer
    if (!('IntersectionObserver' in window)) {
      // Fallback: add class immediately if IntersectionObserver is not supported
      this.section.classList.add('footer-top-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        // Trigger when section is 100px from entering viewport
        rootMargin: '0px 0px -100px 0px',
        threshold: 0.1
      }
    );

    observer.observe(this.section);
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('footer-top-visible');
        // Optionally unobserve after adding class (one-time trigger)
        // observer.unobserve(entry.target);
      }
    });
  }
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FooterTopObserver();
  });
} else {
  new FooterTopObserver();
}

